import React, { Component } from "react";

// import components and packages
import { CommonValidationMessages } from '../../utils/Messages';
import CategoryCampaignButtonGroup from "../../components/entrymanagement/CategoryCampaignButtonGroup";
import EditDetail from "../../components/entrymanagement/EditDetail";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import { Navigate } from "react-router-dom";

//import API services
import EntryManagementServices from "../../services/axiosServices/apiServices/EntryManagementServices";
import SwalServices from "../../services/swalServices/SwalServices";
import FinanceServices from "../../services/axiosServices/apiServices/FinanceServices";
import { checkParameters, encryptAES } from "../../utils/Encryption";
import { getAuditContext } from "../../utils/AuthenticationLibrary";


export default class CategoryCampaignTagging extends Component {
    constructor(props) {
        super(props);
        this.EntryManagementServices = new EntryManagementServices();
        this.financeService = new FinanceServices();
        this.SwalServices = new SwalServices();
        this.state = {

            route: "",
            carouselData: [
                {
                    id: 1,
                    img: "/default-img.png",
                },
                {
                    id: 2,
                    img: "/default-img.png",
                },
                {
                    id: 3,
                    img: "/default-img.png",
                },
            ],
            categoryEntry: [],
            campaignList: [],

            categoryCampaignItem: {
                eventId: 0,
                eventTypeId:0,
                entryCategory: 0,
                campaign: 0,
                metaTitle: "",
                metaKeyword: "",
                metaDescription: "",
                isFeatured: true,
                isReminderEmail: false,
                visibilityId: 0,
                eventAbout: "",
                outlineDescription: "",
                speakerDescription: "",
                readMoreDescription: "",
                eventFormEndTime: "",
                statusId: 2,

                isPublic: true,
                isHidden: false,
                isPrivate: false,

                selectedCategoryEntryIds: [],
                selectedCampaignIds: [],
                selectedPaymentCategoryIds: [],
                selectedCampaignId: 0,
                selectedCategoryLabel: "",
                selectedCampaignLabel: "",
                financeAccountCodeId: 0,
                financeClassCodeId: 0,
                revenueAccountCodeId: 0,
                revenueClassCodeId: 0,
                paymentCategory: 0,
                cpdPoints: 0,
                eventCertificateType:0,
                createdAppId:0,
                createdBy:0
            },
            entryPricingDetails: {
                eventId: 0,
                eventTimeSlotId: 0,
                eventLessonId: 0,
                locationId: 0,
                eventLessonDate: "",
                eventStartTime: "",
                eventEndTime: "",
                locationAreaName: "",
                totalHours: 0,
                eventPackageList: [],
            },
            selectionDisplay: [],
            eventId: 1,
            isLoading: false,
            financeClassCodes: [],
            financeAccountCodes: [],
            paymentCategory: [
                { value: 1, label: "Internet Bank Transfer" },
                { value: 2, label: "Pay Now" },
                { value: 3, label: "Cheque" },
                { value: 4, label: "Nets Payment" }
            ],
            EventCertificateType: [
                { id: 1, name: "None" },
                { id: 2, name: "CSIS" },
                { id: 3, name: "ACRA" }
            ],
            validationRule: {
                selectedCategoryEntryIds: [
                    {
                        type: 'require',
                        message: CommonValidationMessages.SelectRequired.replace('{0}', 'category of entry')
                    }
                ],
                eventAbout: [
                    {
                        type: 'require',
                        message: CommonValidationMessages.FieldRequired.replace('{0}', 'about description')
                    }
                ],
                // financeAccountCodeId: [
                //     {
                //         type: 'require',
                //         message: CommonValidationMessages.SelectRequired.replace('{0}', 'account code')
                //     }
                // ],
                eventCertificateType : [
                    {
                        type: 'require',
                        message: CommonValidationMessages.SelectRequired.replace('{0}', 'certificate type')
                    }
                ],
                // financeClassCodeId: [
                //     {
                //         type: 'require',
                //         message: CommonValidationMessages.SelectRequired.replace('{0}', 'class code')
                //     }
                // ],
                // revenueAccountCodeId: [
                //     {
                //         type: 'require',
                //         message: CommonValidationMessages.SelectRequired.replace('{0}', 'revenue account code')
                //     }
                // ],
                // revenueClassCodeId: [
                //     {
                //         type: 'require',
                //         message: CommonValidationMessages.SelectRequired.replace('{0}', 'revenue class code')
                //     }
                // ],
                selectedPaymentCategoryIds: [
                    {
                        type: 'require',
                        message: CommonValidationMessages.SelectRequired.replace('{0}', 'payment category')
                    }
                ],
                // cpdPoints: [
                //     {
                //         type: 'require',
                //         message: CommonValidationMessages.SelectRequired.replace('{0}', 'cpd points')
                //     }
                // ],
            },
            descriptionValidationRule: {
                outlineDescription: [
                    {
                        type: 'require',
                        message: CommonValidationMessages.FieldRequired.replace('{0}', 'outline description')
                    }
                ],
                readMoreDescription: [
                    {
                        type: 'require',
                        message: CommonValidationMessages.FieldRequired.replace('{0}', 'read more description')
                    }
                ],
            },

            validStateDescription: {
                isValid: true,
                error: {}
            },

            validState: {
                isValid: true,
                error: {}
            },
        };
    }

    // Method declaration section start
    componentDidMount() {
        let params = new URLSearchParams(window.location.search);
        let eventId = params.get("");
        if ((eventId = checkParameters(eventId, "Number"))) {
            if (eventId && eventId > 0) {
                this.setState({ eventId: eventId }, () => {
                    this.getAllDropDownForCampaignTagging();
                });
            }
        }
    }

    getEntryTimeSlotDetailForTaggingByEventId = (eventId) => {
        this.EntryManagementServices.getEntryTimeSlotDetailForTaggingByEventId(eventId).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                if (response.responseItem.responseContent !== null) {
                    let detail = response.responseItem.responseContent;
                    //Set entry topic dropdown

                    let startTimeArr = detail.eventStartTime.split(' ');
                    let endTimeArr = detail.eventEndTime.split(' ');

                    let hrMinStart = startTimeArr[0].split(":");
                    let hr1 = Number(hrMinStart[0]);
                    let mn1 = Number(hrMinStart[1]);
                    if (startTimeArr[1]?.toUpperCase() === "AM" && hr1 === 12) {
                        hr1 = 0;
                    } else if (startTimeArr[1]?.toUpperCase() === "PM" && hr1 !== 12) {
                        hr1 += 12;
                    }
                    let timeT1 = hr1 + (mn1 / 60);

                    let hrMinEnd = endTimeArr[0].split(":");
                    let hr2 = Number(hrMinEnd[0]);
                    let mn2 = Number(hrMinEnd[1]);
                    if (endTimeArr[1]?.toUpperCase() === "AM" && hr2 === 12) {
                        hr2 = 0;
                    } else if (endTimeArr[1]?.toUpperCase() === "PM" && hr2 !== 12) {
                        hr2 += 12;
                    }
                    let timeT2 = hr2 + (mn2 / 60);
                    let diff = timeT2 - timeT1;
                    diff = parseFloat(diff).toFixed(2);

                    let data = { ...this.state.entryPricingDetails }
                    data.eventId = detail.eventId;
                    data.eventTimeSlotId = detail.eventTimeSlotId;
                    data.eventLessonId = detail.eventLessonId;
                    data.locationId = detail.locationId;
                    data.eventLessonDate = detail.eventLessonDate;
                    data.eventStartTime = detail.eventStartTime;
                    data.eventEndTime = detail.eventEndTime;
                    data.locationAreaName = detail.locationAreaName;
                    data.totalHours = diff;
                    data.eventPackageList = detail.eventPackageList;
                    this.setState({ entryPricingDetails: data });
                }
            }

        });
    };

    editDetails = () => {
        this.setState({ route: '/CreateEntry/eventId?=' + encryptAES(this.state.eventId) });
    }

    // API method declaration start

    //Get all campaign tagging dropdown method start
    getAllDropDownForCampaignTagging = () => {
        this.EntryManagementServices.getAllDropDownForCampaignTagging().then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {

                let entryCategory = response.responseItem.responseContent.filter(
                    (drp) => drp.dropdownName === "EntryCategory"
                );
                entryCategory = entryCategory.map((p) => ({
                    value: p.id,
                    label: p.name,
                }));

                let campaignType = response.responseItem.responseContent.filter(
                    (drp) => drp.dropdownName === "Campaign"
                );
                campaignType = campaignType.map((p) => ({
                    value: p.id,
                    label: p.name,
                }));
                this.setState({ campaignList: campaignType, categoryEntry: entryCategory }, () => {
                    //this.getAllDropdownsForFinanceAdhokInvoices();
                    if (this.state.eventId > 0) {
                     this.getCampaignTaggingDetailsByEventId(this.state.eventId);
                   }

                });
            } else {
                //this.getAllDropdownsForFinanceAdhokInvoices();
                 if (this.state.eventId > 0) {
                     this.getCampaignTaggingDetailsByEventId(this.state.eventId);
                   }
                this.SwalServices.Error(response.message);
            }
        });
    };
    // 

    getCampaignTaggingDetailsByEventId = (eventId) => {
        this.EntryManagementServices.getCampaignTaggingDetailsByEventId(eventId).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                let detail = response.responseItem.responseContent;

                if (response.responseItem.responseContent.paymentMethod && response.responseItem.responseContent.paymentMethod !== 0 && response.responseItem.responseContent.paymentMethod !== "0") {
                    let array1 = (response.responseItem.responseContent.paymentMethod !== null || response.responseItem.responseContent.paymentMethod !== "") ? response.responseItem.responseContent.paymentMethod.split(',') : [];
                    var industriesServedArray = [];
                    const filteredArray = array1.filter(value => value !== "0");
                    if (filteredArray && filteredArray.length > 0) {
                        filteredArray?.forEach(topic => {
                            industriesServedArray.push(this.state.paymentCategory.find(topics => topics.value === Number(topic)));
                        });
                    }
                    detail.selectedPaymentCategoryIds = industriesServedArray
                } else {
                    detail.selectedPaymentCategoryIds = this.state.paymentCategory.filter((x) => x.label === 'Credit Card')
                }

                if (response.responseItem.responseContent !== null) {
                    //Set entry topic dropdown
                    let array = response.responseItem.responseContent.entryCategory
                        ? response.responseItem.responseContent.entryCategory.split(",") : [];
                    let topics = [];
                    array?.forEach((topic) => {
                        topics.push(
                            this.state.categoryEntry.find(
                                (topics) => topics.value === Number(topic)
                            )
                        );
                    });
                    detail.selectedCategoryEntryIds = topics;
                    let str1 = '';
                    // Set selection display data entry topics
                    if (detail.selectedCategoryEntryIds.length > 0) {
                        let arr3 = detail.selectedCategoryEntryIds.map(function (item) {
                            delete item.bad;
                            return item.label;
                        });
                        str1 = arr3.join([',']);
                    }
                    detail.selectedCategoryLabel = str1.split(",")

                    let campaignId = response.responseItem.responseContent.campaign ? Number(response.responseItem.responseContent.campaign) : 0;
                    let topics2 = {};

                    detail.selectedCampaignId = campaignId;
                    if (campaignId > 0) {
                        topics2 = this.state.campaignList.find((topics2) => topics2.value === campaignId);
                        detail.selectedCampaignId = topics2.value;
                    }

                    if (topics2 && topics2 !== null) {
                        let arr4 = [topics2];
                        let str1 = arr4.join([',']);
                        detail.selectedCampaignLabel = topics2.label;
                    }
                    let allSelected = [];
                    if (!detail.selectedCategoryLabel) {
                        allSelected = detail.selectedCampaignLabel
                    }
                    else if (!detail.selectedCampaignLabel) {
                        allSelected = detail.selectedCategoryLabel;
                    }
                    else {
                        allSelected = detail.selectedCategoryLabel.concat(detail.selectedCampaignLabel);
                    }
                    this.setState({ selectionDisplay: allSelected }, () => {
                        if (detail.visibilityId === 1) {
                            detail.isPublic = true;
                            detail.isPrivate = false;
                            detail.isHidden = false;
                        }
                        else if (detail.visibilityId === 2) {
                            detail.isPrivate = true;
                            detail.isPublic = false;
                            detail.isHidden = false;
                        }
                        else if (detail.visibilityId === 3) {
                            detail.isHidden = true;
                            detail.isPublic = false;
                            detail.isPrivate = false;
                        }
                        this.setState({ categoryCampaignItem: detail }, () => this.getEntryTimeSlotDetailForTaggingByEventId(this.state.eventId));
                    });
                }
            } else {
                this.getEntryTimeSlotDetailForTaggingByEventId(this.state.eventId);
                SwalServices.Error(response.message);
            }
        });
    };

    // Add edit campaign tagging details method start
    addEditCampaignTaggingDetails = (id) => {

        let isValidAllTagging = this.isValidateAllFields();
        if (!isValidAllTagging) {
            return;
        }
        if (this.state.categoryCampaignItem.eventTypeId === 1 || this.state.categoryCampaignItem.eventTypeId === 4 || this.state.categoryCampaignItem.eventTypeId === 2 || this.state.categoryCampaignItem.eventTypeId === 6) {
            let request = { ...this.state.categoryCampaignItem };
            request.statusId = id;
            if (request['isPrivate'] === true) {
                request['visibilityId'] = 2;
            }
            else if (request['isHidden'] === true) {
                request['visibilityId'] = 3;
            }
            else {
                request['visibilityId'] = 1;
            }
            request.campaign = request.selectedCampaignId;
            request.eventCertificateType = this.state.categoryCampaignItem.eventCertificateType

            if (this.state.categoryCampaignItem.selectedPaymentCategoryIds.length > 0) {

                var arr1 = []
                this.state.categoryCampaignItem.selectedPaymentCategoryIds.forEach(item => {
                    if (item && item.value) {
                        arr1.push(item.value);
                    }
                });
                if (arr1.length > 0) {
                    request.paymentMethod = arr1.join([',']);
                }
            }
            const audit = getAuditContext()
            request.createdAppId = audit.appId;
            request.createdBy = audit.adminUserId
            this.EntryManagementServices.addEditCampaignTaggingDetails(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                    this.SwalServices.Success("Entry details inserted successfully.");
                    this.setState({ route: '/ViewEditEntries' });
                } else {
                    this.SwalServices.Error(response.message);
                }
                this.setState({ isLoading: false });
            });
            //}
        }
        else {
            if (isValidAllTagging) {
                let request = { ...this.state.categoryCampaignItem };
                request.statusId = id;
                if (request['isPrivate'] === true) {
                    request['visibilityId'] = 2;
                }
                else if (request['isHidden'] === true) {
                    request['visibilityId'] = 3;
                }
                else {
                    request['visibilityId'] = 1;
                }
                request.campaign = request.selectedCampaignId;
                request.eventCertificateType = this.state.categoryCampaignItem.eventCertificateType

                if (this.state.categoryCampaignItem.selectedPaymentCategoryIds.length > 0) {

                    var arr2 = []
                    this.state.categoryCampaignItem.selectedPaymentCategoryIds.forEach(item => {
                        if (item && item.value) {
                            arr2.push(item.value);
                        }
                    });
                    if (arr2.length > 0) {
                        request.paymentMethod = arr2.join([',']);
                    }
                }

                this.EntryManagementServices.addEditCampaignTaggingDetails(request).then((response) => {
                    if (response.statusCode === 200 && response.responseItem != null) {
                        this.SwalServices.Success("Entry details inserted successfully.");
                        this.setState({ route: '/ViewEditEntries' });
                    } else {
                        this.SwalServices.Error(response.message);
                    }
                    this.setState({ isLoading: false });
                });
            }
        }
    };
    // Add edit campaign tagging details method end
    // API method declaration end

    getDynamicValidationRules = (categoryCampaignItem, baseRules) => {
        var rules = { ...baseRules };

        if (categoryCampaignItem.eventTypeId === 5) {
            delete rules.selectedPaymentCategoryIds;
        }

        return rules;
    };

    validateField = (key) => {
        const dynamicRules = this.getDynamicValidationRules(this.state.categoryCampaignItem, this.state.validationRule);
        const newValidState = validate(key, this.state.categoryCampaignItem, dynamicRules, this.state.validState);
        this.setState({ validState: newValidState });
    };

    isValidateAllFields = () => {
        const dynamicRules = this.getDynamicValidationRules(this.state.categoryCampaignItem, this.state.validationRule);
        const newValidState = isValidForm(this.state.categoryCampaignItem, dynamicRules, this.state.validState);
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };


    validateFieldDescription = (key) => {
        const newValidState = validate(key, this.state.categoryCampaignItem, this.state.descriptionValidationRule, this.state.validStateDescription);
        this.setState({ validStateDescription: newValidState });
    };

    isValidateAllFieldsDescription = () => {
        const newValidState = isValidForm(this.state.categoryCampaignItem, this.state.descriptionValidationRule, this.state.validStateDescription);
        this.setState({ validStateDescription: newValidState });
        return newValidState.isValid;
    };



    handleChangeInDropdown(selected, drpIdentity) {
        if (drpIdentity === "CategoryEntry") {
            let details = { ...this.state.categoryCampaignItem };
            details.selectedCategoryEntryIds = selected;

            if (details.selectedCategoryEntryIds.length > 0) {
                let arr1 = details.selectedCategoryEntryIds.map(function (item) {
                    delete item.bad;
                    return item.value;
                });
                details.entryCategory = arr1.join([',']);
                this.setState({ categoryCampaignItem: details }, () => {
                    // Set selection display data
                    let concatData = '';
                    if (details.selectedCategoryEntryIds.length > 0) {
                        let arr3 = details.selectedCategoryEntryIds.map(function (item) {
                            delete item.bad;
                            return item.label;
                        });
                        concatData = arr3.concat(details.selectedCampaignLabel);
                    }
                    this.setState({ selectionDisplay: concatData });
                });
            }
            this.validateField("selectedCategoryEntryIds");
        }
        else if (drpIdentity === "CampaignName") {
            let details = { ...this.state.categoryCampaignItem };
            let campaignList = [...this.state.campaignList];
            if (selected.value > 0) {
                details.selectedCampaignId = selected.value;
                this.setState({ categoryCampaignItem: details }, () => {
                    let concatData = [];
                    campaignList.forEach((x) => {
                        if (x.value === details.selectedCampaignId) {
                            // convert selectedCategoryEntryIds to labels
                            let arrLabels = details.selectedCategoryEntryIds.map(item => item.label);
                            concatData = arrLabels.concat(x.label);
                        }
                    });
                    this.setState({ selectionDisplay: concatData })
                });
            } else {
                details.selectedCampaignId = 0;
                this.setState({ categoryCampaignItem: details })
            }
        }
        else if (drpIdentity === "PaymentCategory") {
            let details = { ...this.state.categoryCampaignItem };
            details.selectedPaymentCategoryIds = selected;

            if (details.selectedPaymentCategoryIds.length > 0) {
                let paymentCategories = details.selectedPaymentCategoryIds.map(item => item.value).join(',');
                details.paymentCategory = paymentCategories;
            }
            this.setState({ categoryCampaignItem: details }, () => {
                this.validateField("selectedPaymentCategoryIds");
            });
        }
    };

    handleRadioButtons(event) {
        const value = event.target.checked;
        const id = event.target.id;
        let detail = { ...this.state.categoryCampaignItem };
        detail['isHidden'] = false;
        detail['isPublic'] = false;
        detail['isPrivate'] = false;
        detail[id] = value;
        this.setState({ categoryCampaignItem: { ...detail } });
    };

    setAboutDescription = (data) => {
        let detail = { ...this.state.categoryCampaignItem };
        let re = /<a href="([^"]+)"/g;
        let result = data.replace(re, "<a href='$1' target=\"_blank\" rel=\"noopener noreferrer\"");
        detail["eventAbout"] = result;
        this.setState({ categoryCampaignItem: { ...detail } });
    };

    setOutLineDescription = (data) => {
        let detail = { ...this.state.categoryCampaignItem };
        let re = /<a href="([^"]+)"/g;
        let result = data.replace(re, "<a href='$1' target=\"_blank\" rel=\"noopener noreferrer\"");
        detail["outlineDescription"] = result;
        this.setState({ categoryCampaignItem: { ...detail } });
    };

    setSpeakerDescription = (data) => {
        let detail = { ...this.state.categoryCampaignItem };
        let re = /<a href="([^"]+)"/g;
        let result = data.replace(re, "<a href='$1' target=\"_blank\" rel=\"noopener noreferrer\"");
        detail["speakerDescription"] = result;
        this.setState({ categoryCampaignItem: { ...detail } });
    };

    setReadMoreDescription = (data) => {
        let detail = { ...this.state.categoryCampaignItem };
        let re = /<a href="([^"]+)"/g;
        let result = data.replace(re, "<a href='$1' target=\"_blank\" rel=\"noopener noreferrer\"");
        detail["readMoreDescription"] = result;
        this.setState({ categoryCampaignItem: { ...detail } });
    };

    handleAboutEditorChange(event, editor) {
        const data = editor.getData();
        this.setAboutDescription(data);
    };
    handleOutlineEditorChange(event, editor) {
        const data = editor.getData();
        this.setOutLineDescription(data);
    };
    handleSpeakerEditorChange(event, editor) {
        const data = editor.getData();
        this.setSpeakerDescription(data);
    };
    handleReadMoreEditorChange(event, editor) {
        const data = editor.getData();
        this.setReadMoreDescription(data);
    };

    handleChange(event) {
        const value = event.target.value;
        const name = event.target.name;
        let detail = { ...this.state.categoryCampaignItem };
        detail[name] = value;
        this.setState({ categoryCampaignItem: { ...detail } });
    };

    filterByToggle = (value, e, index, identity) => {
        if (identity === "Featured") {
            let detail = { ...this.state.categoryCampaignItem };
            this.setState({ setToggle: e.target.checked });
            detail.isFeatured = e.target.checked;
            this.setState({ categoryCampaignItem: { ...detail } });
        }
        else if (identity === "ReminderEmail") {
            let detail = { ...this.state.categoryCampaignItem };
            this.setState({ setToggle: e.target.checked });
            detail.isReminderEmail = e.target.checked;
            this.setState({ categoryCampaignItem: { ...detail } });
        }
    };

    redirectToViewEntries = () => {
        this.setState({ route: '/ViewEditEntries' });
    }

    // getAllDropdownsForFinanceAdhokInvoices = () => {
    //     this.financeService.getAllDropdownsForFinanceAdhokInvoices().then((response) => {
    //         if (response.statusCode === 200 && response.responseItem != null) {
    //             let financeClassCodesArry = response.responseItem.responseContent.filter(
    //                 (drp) => drp.dropdownName === "FinanceClassCodes"
    //             );
    //             let financeAccountCodesArry = response.responseItem.responseContent.filter(
    //                 (drp) => drp.dropdownName === "FinanceAccountCodes"
    //             );
    //             financeClassCodesArry = financeClassCodesArry.map((p) => ({ id: p.id, name: p.name }));
    //             financeAccountCodesArry = financeAccountCodesArry.map((p) => ({ id: p.id, name: p.name }));

    //             this.setState({
    //                 financeClassCodes: financeClassCodesArry, financeAccountCodes: financeAccountCodesArry
    //             }, () => {
    //                 if (this.state.eventId > 0) {
    //                     this.getCampaignTaggingDetailsByEventId(this.state.eventId);

    //                 }
    //             });
    //         } else {
    //             if (this.state.eventId > 0) {
    //                 this.getCampaignTaggingDetailsByEventId(this.state.eventId);

    //             }
    //         }
    //     })
    // }

    handleChangeInCodesDropdown = (id, drpIdentity) => {
        let detail = { ...this.state.categoryCampaignItem };
        if (drpIdentity === "financeAccountCodes") {
            detail.financeAccountCodeId = id;
            this.setState({ categoryCampaignItem: detail }, () => {
                this.validateField("financeAccountCodeId");
            });
        }
        if (drpIdentity === "financeClassCodes") {
            detail.financeClassCodeId = id;
            this.setState({ categoryCampaignItem: detail }, () => {
                this.validateField("financeClassCodeId");
            });
        }
        if (drpIdentity === "revenueAccountCodes") {
            detail.revenueAccountCodeId = id;
            this.setState({ categoryCampaignItem: detail }, () => {
                this.validateField("revenueAccountCodeId");
            });
        }
        if (drpIdentity === "revenueClassCodes") {
            detail.revenueClassCodeId = id;
            this.setState({ categoryCampaignItem: detail }, () => {
                this.validateField("revenueClassCodeId");
            });
        }
        if (drpIdentity === "EventCertificateType") {
            detail.eventCertificateType = id;
            this.setState({ categoryCampaignItem: detail }, () => {
                this.validateField("eventCertificateType");
            });
        }
    }


    render() {
        if (this.state.route !== "") {
            return <Navigate to={this.state.route} />;
        }
        return (
            <>
                <div className="main-body-section">
                    <div className="custom-card2 shadow-lg">
                        <CategoryCampaignButtonGroup
                            addEditCampaignTaggingDetails={this.addEditCampaignTaggingDetails.bind(this)}
                            editDetails={this.editDetails.bind(this)}
                            redirectToViewEntries={this.redirectToViewEntries.bind(this)}
                        />
                        <div className="py-8">
                            <EditDetail
                                carouselData={this.state.carouselData}
                                categoryEntry={this.state.categoryEntry}
                                campaignList={this.state.campaignList}
                                reminderEmail={this.state.reminderEmail}
                                categoryCampaignItem={this.state.categoryCampaignItem}
                                selectionDisplay={this.state.selectionDisplay}
                                handleChange={this.handleChange.bind(this)}
                                handleChangeInDropdown={this.handleChangeInDropdown.bind(this)}
                                filterByToggle={this.filterByToggle.bind(this)}
                                handleReadMoreEditorChange={this.handleReadMoreEditorChange.bind(this)}
                                handleAboutEditorChange={this.handleAboutEditorChange.bind(this)}
                                handleOutlineEditorChange={this.handleOutlineEditorChange.bind(this)}
                                handleSpeakerEditorChange={this.handleSpeakerEditorChange.bind(this)}
                                handleRadioButtons={this.handleRadioButtons.bind(this)}
                                filterByFeatured={this.filterByToggle.bind(this)}
                                validState={this.state.validState}
                                validateField={this.validateField.bind(this)}
                                validateFieldDescription={this.validateFieldDescription.bind(this)}
                                validStateDescription={this.state.validStateDescription}
                                entryPricingDetails={this.state.entryPricingDetails}
                                financeClassCodes={this.state.financeClassCodes}
                                financeAccountCodes={this.state.financeAccountCodes}
                                handleChangeInCodesDropdown={this.handleChangeInCodesDropdown.bind(this)}
                                paymentCategory={this.state.paymentCategory}
                                EventCertificateType = {this.state.EventCertificateType}
                            />
                        </div>
                        <CategoryCampaignButtonGroup
                            addEditCampaignTaggingDetails={this.addEditCampaignTaggingDetails.bind(this)}
                            editDetails={this.editDetails.bind(this)}
                            redirectToViewEntries={this.redirectToViewEntries.bind(this)}
                        />
                    </div>
                </div>
            </>
        );
    }
}